import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { CheckoutListSkeletonStyled } from "./CheckoutListStyled";

const CheckoutListSkeleton: React.FC = () => {
  return (
    <CheckoutListSkeletonStyled>
      {[...Array.from({ length: 6 })].map((_item, index: number) => (
        <li key={index}>
          <Skeleton style={{ width: "100%" }} height={32.5} />
        </li>
      ))}
    </CheckoutListSkeletonStyled>
  );
};

export default CheckoutListSkeleton;
